import { z } from 'zod';
import { BuildingClass, BuildingType, DocSuggestionType, MainUse, SimilarityConfidence, } from '../enums.js';
import { projectSummary } from './project.js';
export const similarityInput = z.object({
    customerId: z.number().int().positive().optional(),
    buildingType: BuildingType.optional(),
    buildingClass: BuildingClass.optional(),
    projectType: z.string().optional(),
    mainUse: MainUse.optional(),
    gemarkung: z.string().optional(),
    buildingArea: z.number().optional(),
});
export const findSimilarRequest = z.object({
    projectData: similarityInput,
    minSimilarity: z.number().int().min(0).max(100).default(30),
    maxResults: z.number().int().min(1).max(20).default(5),
});
export const similarityResult = z.object({
    score: z.number().int().min(0).max(100),
    factors: z.array(z.string()),
    confidence: SimilarityConfidence,
});
export const similaritySuggestion = z.object({
    project: projectSummary,
    similarity: similarityResult,
});
export const findSimilarResponse = z.object({
    suggestions: z.array(similaritySuggestion),
    meta: z.object({
        totalCandidates: z.number().int(),
        tookMs: z.number(),
    }),
});
export const analyzeDocumentRequest = z.object({
    filename: z.string().min(1),
});
export const docSuggestion = z.object({
    type: DocSuggestionType,
    confidence: z.number().int().min(0).max(100),
    matchedFields: z.array(z.string()),
    projectId: z.number().int().nullable().optional(),
    customerId: z.number().int().nullable().optional(),
    hint: z.string().optional(),
    /** Bei type='new_customer': aus dem Dateinamen extrahierter Kunden-/Firmenname (Vorbelegung für „Kunde erstellen"). */
    extractedCustomerName: z.string().optional(),
    /** Bei type='existing_liegenschaft': das erkannte Objekt. */
    liegenschaftId: z.number().int().nullable().optional(),
    /** Erkannter Typ aus dem Dokumentkatalog (`dokumentkatalog.json`), unabhängig vom Vorschlagstyp. */
    dokumentTyp: z.string().nullable().optional(),
});
export const analyzeDocumentResponse = z.object({
    suggestions: z.array(docSuggestion),
});
